namespace RioERP.Carts {
    export namespace PermissionKeys {
        export const General = "Carts:General";

        namespace CartsManagement {
            export const Delete = "Carts:CartsManagement:Delete";
            export const Modify = "Carts:CartsManagement:Modify";
            export const View = "Carts:CartsManagement:View";
        }
    }
}
